<div class="welcome">
  <div class="welcome__container">
    <div class="welcome__container__logo">
      <img src="assets/images/logo-bxl.png" alt="logo" />
    </div>

    <div class="welcome__container__text">
      <h1 class="welcome__container__text-title">
        {{ "app_inforius" | translate }}
      </h1>

      <div class="row">
        <div class="col-12 text-center">
          <h1>{{ "errorPage.401.title" | translate }}</h1>
          <p>{{ "errorPage.401.content" | translate }}</p>
        </div>
        <div class="col-12 cta text-center d-flex justify-content-center gap-2">
          <button
            class="btn btn-secondary"
            (click)="login()"
            *ngIf="!isConnected"
          >
            <em class="bi bi-arrow-right-short"></em>
            <span> {{ "auth.connect" | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
